module.exports = __webpack_public_path__ + "static/media/chevron-down-icon.bd3dc4ed.svg";